// src/pages/Cart.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext'; // Importez le hook useCart
import './../styles/styles.css';

export default function Cart() {
  // Utilisez le hook pour accéder à l'état et aux fonctions du panier
  const { cartItems, removeFromCart, updateQuantity } = useCart();

  // Fonction pour calculer le total du panier
  const calculateTotal = () => {
    // Note: On utilise parseFloat car le prix est une chaîne de caractères dans vos données statiques
    // Dans un vrai projet, utilisez des nombres.
    return cartItems.reduce((total, item) => total + parseFloat(item.price) * item.quantity, 0).toFixed(2);
  };

  return (
    <div>
      <section className="section-black cart-header">
        <h1>Votre Panier</h1>
        <p>Vérifiez votre commande avant de finaliser votre achat.</p>
      </section>

      <section className="section-cream cart-content">
        {cartItems.length === 0 ? (
          <div className="empty-cart-message">
            <h2>Votre panier est vide.</h2>
            <p>Découvrez nos jeux et trouvez votre prochaine enquête !</p>
            <Link to="/store" className="cta-button">Aller à la boutique</Link>
          </div>
        ) : (
          <div className="cart-container">
            <div className="cart-items-list">
              {cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.title} className="cart-item-image" />
                  <div className="cart-item-details">
                    <h4>{item.title}</h4>
                    <p> Entre {item.min_players} et {item.max_players} joueurs.</p>
                    <p className="cart-item-price">{item.price} €</p>
                    <div className="cart-item-actions">
                      <button onClick={() => removeFromCart(item.id)} className="remove-item-button">Retirer</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <h3>Résumé de la commande</h3>


              <div className="summary-row total">
                <strong>Total :</strong>
                <strong>{calculateTotal()} €</strong>
              </div>
              <Link to="/checkout" className="cta-button checkout-button">Passer la commande</Link>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}